import { GeoInfo } from 'schemas/GeoInfoSchema'
import GeoType from 'enums/GeoType'

const getLeafNodes = (geoInfos: GeoInfo[]) => {
  const parentIds = geoInfos
    .filter((geoInfo) => geoInfo.parentId)
    .map((geoInfo) => geoInfo.parentId)

  return geoInfos.filter((geoInfo) => !parentIds.includes(geoInfo.id))
}

export const getDisplayTexts = (geoInfos?: GeoInfo[]) => {
  if (!geoInfos) {
    return undefined
  }

  const leafNodes = getLeafNodes(geoInfos)
  return leafNodes ? leafNodes.map((leafNode) => leafNode.name!) : undefined
}

const getParent = (geoInfos: GeoInfo[], target: GeoInfo) =>
  geoInfos.find((geoInfo) => geoInfo.id === target.parentId)

export const getDisplayHierarchies = (geoInfos?: GeoInfo[]) => {
  if (!geoInfos) {
    return undefined
  }

  const leafNodes = getLeafNodes(geoInfos)
  if (!leafNodes) {
    return undefined
  }

  return leafNodes.map((leafNode) => {
    let currentNode = leafNode
    let genenology = leafNode.name
    let parent = getParent(geoInfos, currentNode)
    while (parent) {
      if (parent.geoType !== GeoType.COUNTY) {
        genenology = `${genenology}, ${parent.name}`
      }
      currentNode = parent
      parent = getParent(geoInfos, currentNode)
    }

    return genenology
  })
}
